import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import StickyDemoButton from "./components/feature/StickyDemoButton";
import ChatbotWidget from "./components/feature/ChatbotWidget";
import { AuthProvider } from "./contexts/AuthContext";
import { useEffect } from "react";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppLayout = () => {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/dashboard');

  return (
    <>
      <ScrollToTop />
      {!isDashboard && <Navbar />}
      <AppRoutes />
      {!isDashboard && <Footer />}
      {!isDashboard && <StickyDemoButton />}
      {!isDashboard && <ChatbotWidget />}
    </>
  );
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <AppLayout />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
